import React from "react";
import { Stack, Typography } from "@mui/material";
import Dropzone from "react-dropzone";
import LoadingButton from "../ui/LoadingButton";
import { useIntl } from "../../contexts/IntlContext";
import { ACCEPTED_IMAGE_TYPES } from "../../constants/imageUpload";
import { fontWeights } from "../../themes/fontWeights";

export default function Upload({
  title,
  onUpload,
  onRejected,
  disabled,
  maxFiles = undefined,
}: any) {
  const { formatMessage } = useIntl();

  const renderDragMessage = (isDragActive: any, isDragReject: any) => {
    if (!isDragActive) {
      return <span>{title}</span>;
    }
    if (isDragReject) {
      return (
        <span>
          {formatMessage({
            id: "upload.unsupportedFile",
            defaultMessage: "Formato não suportado",
          })}
        </span>
      );
    }

    return (
      <span>
        {formatMessage({
          id: "upload.dropFiles",
          defaultMessage: "Solte os arquivos aqui",
        })}
      </span>
    );
  };

  return (
    <Dropzone
      accept={ACCEPTED_IMAGE_TYPES}
      onDropAccepted={onUpload}
      onDropRejected={onRejected}
      disabled={disabled}
      maxFiles={maxFiles}
    >
      {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
        <Stack spacing={0.5} alignItems="flex-start">
          <LoadingButton
            {...getRootProps()}
            size="small"
            variant="contained"
            color="primary"
            disabled={disabled}
            sx={{
              fontWeight: fontWeights.semiBold,
              minWidth: 160,
              boxShadow: "none",
              "&:hover": { boxShadow: "none" },
            }}
          >
            <input {...getInputProps()} />
            {renderDragMessage(isDragActive, isDragReject)}
          </LoadingButton>
          <Typography variant="caption" color="textSecondary">
            {formatMessage({
              id: "upload.acceptedFormats",
              defaultMessage: "Formatos aceitos: PNG, JPEG, GIF",
            })}
          </Typography>
        </Stack>
      )}
    </Dropzone>
  );
}
